import { isExperimentActive } from '../../utils/experiments';
import { createSelector } from 'reselect';
import { selectExperiments } from './selectExperiments';
import {
  servicesVerticalCardsExperimentGroups,
  servicesVerticalCardsExperimentName,
} from '../../constants/experiments/servicesCardsVerticalDesignExperiment';

export const selectServiceVerticalCardsExperiment = createSelector([selectExperiments], experiments => {
  return isExperimentActive(
    experiments,
    servicesVerticalCardsExperimentName,
    servicesVerticalCardsExperimentGroups.test,
  );
});
